"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var Menu = function (_a) {
    var type = _a.type, width = _a.width, height = _a.height, fill = _a.fill;
    switch (type) {
        case 'line':
        default:
            return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none" },
                React.createElement("path", { fill: fill, d: "M7.27271 10H32.7272C32.7272 11.8409 31.2077 13.3333 29.3333 13.3333H7.27271V10Z" }),
                React.createElement("path", { fill: fill, d: "M7.27271 18.3333H32.7272C32.7272 20.1743 31.2077 21.6666 29.3333 21.6666H7.27271V18.3333Z" }),
                React.createElement("path", { fill: fill, d: "M7.27271 26.6667H32.7272C32.7272 28.5076 31.2077 30 29.3333 30H7.27271V26.6667Z" })));
    }
};
Menu.propTypes = {
    type: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
};
Menu.defaultProps = {
    type: 'solid',
    width: 40,
    height: 40,
    fill: colors_1.grey5,
};
exports.default = Menu;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVudS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9NZW51LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZCQUErQjtBQUMvQixzQ0FBd0M7QUFFeEMsb0NBQWdDO0FBUWhDLElBQU0sSUFBSSxHQUF3QixVQUFDLEVBQTJCO1FBQTFCLGNBQUksRUFBRSxnQkFBSyxFQUFFLGtCQUFNLEVBQUUsY0FBSTtJQUMzRCxRQUFRLElBQUksRUFBRTtRQUNaLEtBQUssTUFBTSxDQUFDO1FBQ1o7WUFDRSxPQUFPLENBQ0wsNkJBQUssS0FBSyxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBQyxXQUFXLEVBQUMsSUFBSSxFQUFDLE1BQU07Z0JBQ2hFLDhCQUFNLElBQUksRUFBRSxJQUFJLEVBQUUsQ0FBQyxFQUFDLGlGQUFpRixHQUFHO2dCQUN4Ryw4QkFDRSxJQUFJLEVBQUUsSUFBSSxFQUNWLENBQUMsRUFBQywyRkFBMkYsR0FDN0Y7Z0JBQ0YsOEJBQU0sSUFBSSxFQUFFLElBQUksRUFBRSxDQUFDLEVBQUMsaUZBQWlGLEdBQUcsQ0FDcEcsQ0FDUCxDQUFDO0tBQ0w7QUFDSCxDQUFDLENBQUM7QUFFRixJQUFJLENBQUMsU0FBUyxHQUFHO0lBQ2YsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFhO0lBQzdCLEtBQUssRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDdkUsTUFBTSxFQUFFLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxTQUFTLENBQUMsTUFBTSxFQUFFLFNBQVMsQ0FBQyxNQUFNLENBQUMsQ0FBUTtJQUN4RSxJQUFJLEVBQUUsU0FBUyxDQUFDLE1BQU07Q0FDdkIsQ0FBQztBQUVGLElBQUksQ0FBQyxZQUFZLEdBQUc7SUFDbEIsSUFBSSxFQUFFLE9BQU87SUFDYixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7Q0FDWixDQUFDO0FBRUYsa0JBQWUsSUFBSSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Menu.js
// module id = 80
// module chunks = 0